<template>
  <div
    class="pending-action-item generic-border generic-border--clickable generic-border--card"
    :class="mainElementClasses"
    @click="actionClick"
  >
    <div class="drag-item">
      <DraggingIndication v-if="!noDragHandle" class="pending-action-item__drag-indicator" />
      <div class="pending-action-item__content">
        <div class="pending-action-item__basics">
          <div class="pending-action-item__basics__wrapper">
            <EllipsisDiv class="pending-action-item__basics__description" :text="safeAutocompleteString(value.name)" />
            <div
              v-if="value.problem > 0"
              class="pending-action-item__basics__description__problem"
              @click.stop="$router.push(getPbSheetLink(value.problem))"
            >
              <Icon>
                {{ archivesMedium }}
              </Icon>
              <div>{{ $t('message.PROBLEM') + $t('message.TWO_DOTS') }} {{ value.lWhat }}</div>
            </div>
          </div>
          <div class="pending-action-item__basics__tags h-v-centerer">
            <Icon v-if="Number(value.isSupport) === 1" v-quick-title="$t('message.ACTION_FROM_OTHER_TEAM')">
              {{ share }}
            </Icon>
            <Icon v-if="isSecuring" :class="securingIconClass(null, value)">
              {{ securing }}
            </Icon>
          </div>
          <div class="pending-action-item__basics__leader h-v-centerer">
            <UserThumbnail
              :value="value.leader || 0"
              :placeholder="$t('message.NO_LEADER')"
              fetch-data
              :show-name="!$store.state.device.isSmartphonePortrait"
              disabled
            />
          </div>
          <div class="pending-action-item__basics__impact h-v-centerer">
            <ImpactIndicator :value="Number(value.impact)" :min="!!elClasses['sm-portrait-size']" />
          </div>
          <div
            class="pending-action-item__basics__deadline h-v-centerer"
            :class="{ 'pending-action-item__basics__deadline--disabled': !value.deadline }"
          >
            <span>{{ displayedDeadline }}</span>
          </div>

          <div class="pending-action-item__basics__delete h-v-centerer">
            <div
              class="generic-border generic-border--icon-button generic-border--clickable generic-border--blue-border"
              @click.stop="deleteAction"
            >
              <Icon>{{ deleteMedium }}</Icon>
            </div>
          </div>
        </div>
      </div>
      <!-- Keep this as we are not sure about the design yet -->
      <!-- <div v-if="value.problem != 0">
        <div class="sep" />
        <table>
          <td class="pending-action-item__td">
            <EditableLabel
              v-model="value.lWhat"
              :legend="$t('message.PROBLEM') + $t('message.TWO_DOTS')"
              disabled
            />
            <EditableLabel
              v-model="value.causeText"
              :legend="$t('message.CAUSE') + $t('message.TWO_DOTS')"
              disabled
            />
            <button class="see-sheet add-button reverse" @click.stop="$emit('sheetClick')">
              {{ $t('message.PROBLEM_SHEET') }}<img src="/images/see.png" alt="">
            </button>
          </td>
          <td class="pending-action-item__td pending-action-item-pbimg">
            <img :src="fUtilsFirstPictureData" alt="">
          </td>
        </table>
      </div> -->
    </div>
  </div>
</template>

<script>
/**
 * Item in an actions list
 *
 * @vue-prop {Object} value - action item data
 * @vue-prop {Boolean} noDragHandle - Allow drag element or not
 */

import $ from 'jquery';
// Components
// Design uncertainty
// import EditableLabel from '@/components/editable-label.vue';
import DraggingIndication from '@/components/dragging-indication.vue';
import EllipsisDiv from '@/components/ellipsize.vue';
import Icon from '@/components/icon.vue';
import ImpactIndicator from '@/components/impact-indicator.vue';
import UserThumbnail from '@/components/user-thumbnail.vue';
// Mixins
import mixinFileUtils from '@/mixins/file-utils.vue';
import mixinSocketHandler from '@/mixins/socket-handler.vue';
// Utils
import { archivesMedium, deleteMedium, securing, share } from '@/assets/icons';
import { decodeHTML, safeAutocompleteString, itemWidthClasses } from '@/utils/main';
import { securingIconClass } from '@/utils/problem-utils';


export default {

  name: 'PendingActionItem',

  components: {
    // Design uncertainty
    // EditableLabel,
    DraggingIndication,
    EllipsisDiv,
    Icon,
    ImpactIndicator,
    UserThumbnail,
  },

  mixins: [mixinSocketHandler, mixinFileUtils],

  props: {
    value: {
      type: Object,
      required: true,
    },
    noDragHandle: Boolean,
  },

  data() {
    return {
      archivesMedium,
      deleteMedium,
      securing,
      share,
      titleKey: 1,
      elClasses: '',
    };
  },

  computed: {
    /** Object: Classes applied to this.$el */
    mainElementClasses() {
      return {
        ...this.elClasses,
      };
    },
    /** Placeholder when no leader selected */
    leaderPlaceholder() {
      return !this.value.teamName
        ? this.$t('message.NO_LEADER')
        : this.$t('message.AFFECT_TEAM_NO_LEADER', { team: decodeHTML(this.value.teamName || this.currentTeam.name) });
    },
    /** Value is a securing action */
    isSecuring() {
      return this.value.isSecuring === 1;
    },
    /** Array: Array of file IDs for file-utils mixins */
    fUtilsFileIds() {
      return this.value.problemFiles;
    },
    /** String: Text to display for the deadline column */
    displayedDeadline() {
      return this.value.deadline
        ? this.$moment(this.value.deadline).format(this.$t('fullDateFormat'))
        : this.$t('message.TO_BE_DEFINED');
    },
  },

  watch: {
    value() {
      this.onSizeChanged();
    },
  },

  created() {
    $(window).on(`resizeEnd.${this.uuid}`, () => {
      this.onSizeChanged();
      // Reset the title EditableLabel to update the ellipsis
      this.titleKey++;
    });
  },

  mounted() {
    this.onSizeChanged();
  },

  beforeDestroy() {
    $(window).off(`resizeEnd.${this.uuid}`);
  },

  methods: {
    safeAutocompleteString,
    securingIconClass,
    actionClick() {
      this.$emit('actionClick');
    },
    deleteAction() {
      this.$emit('deleteClick');
    },
    /** Style of the item is determined by the size of $el. Apply classes */
    onSizeChanged() {
      const width = this.$el ? this.$el.offsetWidth : 0;
      this.elClasses = itemWidthClasses
        .reduce((classes, wc) => ({ ...classes, [wc.className]: width <= wc.width }), {});
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";

.pending-action-item {
  position: relative;
  background: white;
  box-sizing: border-box;
  padding: 0.7rem 0;

  &__drag-indicator {
    position: absolute;
    top: 50%;
    left: 0.3rem;
    transform: translateY(-50%);
  }

  &__basics {
    display: flex;
    align-items: center;

    &__wrapper {
      flex: 1;
      min-width: 0px;
    }

    &__description {
      min-width: 0;
      margin-left: 1.3rem;
      line-height: 1.3rem;
      height: 2.6rem;
      font-weight: 600;
      display: flex;
      align-items: center;
      font-size: 1rem;

      .ellipsis-div {
        height: 100%;
      }

      &__problem {
        transition: background 0.3s ease;
        font-size: 0.8em;
        text-decoration: underline;
        display: flex;
        margin-left: 1rem;
        margin-top: 0.3rem;
        padding-left: .3rem;
        align-items: center;
        box-sizing: border-box;
        border-radius: $small-border-radius;

        svg {
          flex: 0 0 .8rem;
          width: .8rem;
          margin-right: 6px;
        }

        div {
          flex: 1;
          min-width: 0;
          text-overflow: ellipsis;
          overflow: hidden;
          white-space: nowrap;
        }

        &:hover {
          background-color: $main-hover-color;
        }
      }
    }

    &__tags {
      flex: 0 0 3rem;
      flex-wrap: wrap;

      .icon, img {
        width: 1rem;
        height: 1rem;
        margin: 0.2em;
        padding: 0.35rem;
        background: $color-gray-background;
        border-radius: $small-border-radius;
      }
    }

    &__leader {
      font-size: 0.85rem;
      flex: 0 0 12rem;
    }

    &__impact {
      flex: 0 0 11rem;
    }

    &__deadline {
      flex: 0 0 11rem;
      font-size: 0.85rem;

      &--disabled {
        opacity: 0.7;
      }
    }

    &__delete {
      flex: 0 0 5.72rem;
    }
  }

  &__td {
    padding: 0px;
    width: 100%;
    vertical-align: top;
  }

  &:not(:first-child) {
    margin-top: .7rem;
  }

  .sep {
    width: 80%;
    margin: 5px 10% 10px 10%;
  }

  table {
    border-collapse: collapse;
    table-layout: fixed;

    .pending-action-item-pbimg {
      width: 70px;

      img {
        width: 60px;
        height: 60px;
        object-fit: cover;
      }
    }
  }

  &.sm-landscape-size {

    .pending-action-item {

      &__basics {

        &__leader {
          flex: 0 0 8rem;
        }

        &__impact {
          flex: 0 0 8rem;
        }

        &__deadline {
          flex: 0 0 6rem;
        }

        &__delete {
          flex: 0 0 4.72rem;
        }
      }
    }
  }
}

.pending-action-item {

  &.sm-portrait-size {

    .pending-action-item {

      &__basics {

        &__leader {
          flex: 0 0 4rem;
        }

        &__impact {
          flex: 0 0 4rem;
        }

        &__deadline {
          display: none;
        }
      }
    }
  }
}
</style>
